import { IAdSources, IAdSourcesState } from '@/api/types';
import { IThunkAPI } from '@/store/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllAdSources } from '@/api/admin/advertising-sources';

export const initialState: IAdSources = {
  isAdSourcesFetching: false,
  isAdSourcesSuccess: false,
  isAdSourcesError: false,
  adSources: [],
};

export const getAdSources = createAsyncThunk<IAdSourcesState[], void, IThunkAPI>(
  'get/adSource',
  async (_, thunkAPI) => {
    try {
      const response = await getAllAdSources();
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const adSourceSlice = createSlice({
  name: 'adSource',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAdSources.fulfilled, (state, action) => {
        state.isAdSourcesError = false;
        state.isAdSourcesFetching = false;
        state.isAdSourcesSuccess = true;
        state.adSources = action.payload;
      })
      .addCase(getAdSources.pending, state => {
        state.isAdSourcesError = false;
        state.isAdSourcesSuccess = false;
        state.isAdSourcesFetching = true;
      })
      .addCase(getAdSources.rejected, state => {
        state.isAdSourcesError = true;
        state.isAdSourcesFetching = false;
        state.isAdSourcesSuccess = false;
      });
  },
});

export default adSourceSlice.reducer;
